<script>
import { mapActions, mapGetters } from 'vuex'
import CustomStore from 'devextreme/data/custom_store'
import { awaitLoading } from '@/services/grid'
import { queryGrid } from '@/services/crud'

export default {
  props: {
    selection: {
      default: false
    },
    tela: {
      default: false
    },
    datasource: {},
    columns: {
      type: Array
    },
    indices: {
      type: Array
    },
    acoes: {
      type: Object,
      default: () => ({
        add: null,
        edit: null,
        delete: null
      })
    },
    outrosBotoes: {
      type: Array,
      default: () => ([])
    }
  },
  mounted () {
    this.carregaIndicesBusca()
    this.carregaRelatorios()
  },
  computed: {
    ...mapGetters({
      funcionalidades: 'auth/funcionalidades',
      relatoriosTela: 'auth/relatoriosTela',
      impressaoTela: 'auth/impressaoTela'
    }),
    permissoes () {
      let obj = {
        add: { visivel: false, habilitado: false, pedir_senha: false },
        edit: { visivel: false, habilitado: false, pedir_senha: false },
        delete: { visivel: false, habilitado: false, pedir_senha: false }
      }
      if (this.acoes.add) obj.add = this.funcionalidades(this.acoes.add)
      if (this.acoes.edit) obj.edit = this.funcionalidades(this.acoes.edit)
      if (this.acoes.delete) obj.delete = this.funcionalidades(this.acoes.delete)
      if (this.outrosBotoes.length > 0) {
        this.outrosBotoes.forEach(e => {
          obj[e.permissao] = this.funcionalidades(e.permissao)
        })
      }
      return obj
    }
  },
  watch: {
    indices () {
      this.carregaIndicesBusca()
    }
  },
  data () {
    return {
      // Data Grid Options
      dtSource: { store: new CustomStore({ load: this.getList }) },
      remoteOperations: { sorting: true, paging: true },
      paging: { pageSize: 10 },
      pager: { showPageSizeSelector: true, allowedPageSizes: [ 10, 15, 20 ] },
      scrolling: {
        type: Object,
        required: false,
        default: () => ({
          columnRenderingMode: 'virtual',
          mode: 'standard',
          preloadEnabled: true,
          rowRenderingMode: 'virtual',
          scrollByContent: true,
          scrollByThumb: true,
          showScrollbar: 'always',
          useNative: false
        })
      },
      // Component data
      filtros: {},
      indicesBusca: [],
      busca: '',
      dblClick: {
        id: false,
        timeout: 10000
      },
      relatorios: [],
      impressao: false
    }
  },
  methods: {
    ...mapActions({
      toaster: 'modal/toaster',
      validaSenhaAsync: 'auth/validaSenhaAsync',
      openRelatorio: 'relatorio/open',
      openPrint: 'relatorio/openPrint'
    }),
    async onContentReady (component) {
      let gridInstance = this.$refs.dataGrid.instance
      await awaitLoading(gridInstance)
      this.focoPesquisa()
      this.selecionaPrimeiraLinha()
      this.scrollToLine()
    },
    loadTollbar (e) {
      let toolbarItems = e.toolbarOptions.items
      toolbarItems.unshift({ location: 'before', template: 'pesquisaDiv' })
      toolbarItems.unshift({ location: 'after', template: 'selecionarDiv' })
      toolbarItems.unshift({ location: 'after', template: 'relatorioDiv' })
      toolbarItems.unshift({ location: 'after', template: 'printDiv' })
      toolbarItems.unshift({ location: 'after', template: 'refreshDiv' })
      toolbarItems.unshift({ location: 'after', template: 'addDiv' })
    },
    carregaIndicesBusca () {
      this.indices.forEach(e => {
        this.indicesBusca.push(e.value)
      })
    },
    changeFiltro (parametros) {
      this.filtros = Object.assign({}, this.filtros, parametros)
    },
    async getList (parametros) {
      this.changeFiltro(parametros)
      let filtros = queryGrid(this.filtros)
      let retorno = await this.datasource(filtros)
      return retorno
    },
    async print () {
      await this.validaPermissaoRelatorio(this.impressao)
      let filtros = queryGrid(this.filtros)
      this.openPrint({ id: this.impressao.id, filtros })
    },
    async refreshList () {
      let grid = this.$refs.dataGrid
      await grid.instance.refresh()
    },
    scrollToLine () {
      let index = this.verificaSelecionado()
      if (index !== false) {
        let gridInstance = this.$refs.dataGrid.instance
        let scrollable = gridInstance.getScrollable()
        let el = gridInstance.getCellElement(index, 0)
        scrollable.scrollToElement(el.nextElementSibling)
      }
    },
    async selectRowKey (action) {
      // Variaveis
      let gridInstance = this.$refs.dataGrid.instance
      let result = gridInstance.getDataSource().items()
      let pageIndex = gridInstance.pageIndex()
      let lastPageIndex = gridInstance.pageCount() - 1
      let rowSelect = this.getRowSelect()
      let selectIndex = -1
      let lastIndex = result.length - 1
      let firstIndex = 0
      let lastReg = false
      let firstReg = false
      // Verifica index e posicao do selecionado
      result.forEach((el, index) => {
        if (el.id === rowSelect.id) {
          selectIndex = index
          if (index === lastIndex) lastReg = true
          else if (index === firstIndex) firstReg = true
        }
      })
      // Determina proximo Index
      let nextIndex = action === 'up' ? selectIndex - 1 : selectIndex + 1
      nextIndex = nextIndex === -2 ? nextIndex = -1 : nextIndex

      // Ultimo Registro e Passa para Proxima Pagina
      if (lastReg && action === 'down' && pageIndex !== lastPageIndex) {
        await gridInstance.pageIndex(pageIndex + 1)
        gridInstance.deselectAll()
        return this.selectRowKey(action)
      // Ultimo Registro e Passa para Primeira Pagina
      } else if (lastReg && action === 'down' && pageIndex === lastPageIndex) {
        await gridInstance.pageIndex(0)
        gridInstance.deselectAll()
        return this.selectRowKey(action)
      // Primeiro Registro Volta uma Página
      } else if (firstReg && action === 'up' && pageIndex !== 0) {
        await gridInstance.pageIndex(pageIndex - 1)
        gridInstance.deselectAll()
        nextIndex = gridInstance.pageSize() - 1
        gridInstance.selectRowsByIndexes(nextIndex)
        this.scrollToLine()
      // Passa proximo item
      } else if (!(lastReg && action === 'down') && !(firstReg && action === 'up')) {
        gridInstance.selectRowsByIndexes(nextIndex)
        this.scrollToLine()
      }
    },
    getRowSelect () {
      let rowSelect = this.$refs.dataGrid.instance.getSelectedRowsData()
      rowSelect = rowSelect ? rowSelect[0] || {} : {}
      return rowSelect
    },
    verificaSelecionado () {
      let row = this.getRowSelect()
      let result = this.$refs.dataGrid.instance.getDataSource().items()
      let selecionado = false
      result.forEach((el, index) => {
        if (el.id === row.id) selecionado = index
      })
      return selecionado
    },
    async selecionaPrimeiraLinha () {
      if (this.verificaSelecionado() === false) this.$refs.dataGrid.instance.selectRowsByIndexes(0)
    },
    setRegistro () {
      if (this.selection && this.verificaSelecionado() !== false) this.$emit('onSelect', this.getRowSelect())
    },
    focoPesquisa () {
      let campoBusca = this.$refs.campoBusca
      campoBusca.$el.children[0].focus()
      campoBusca.$el.children[0].children[1].focus()
    },
    clickRow (e) {
      let tempo = new Date().getTime() - this.dblClick.timeout
      if (this.dblClick.id === e.data.id && tempo < 1000) this.setRegistro()
      else {
        this.dblClick.id = e.data.id
        this.dblClick.timeout = new Date().getTime()
      }
      this.focoPesquisa()
    },
    changeBusca (busca) {
      this.busca = busca
      return this.executaBusca()
    },
    async executaBusca () {
      this.changeFiltro({ where: { qFields: this.indicesBusca, q: this.busca } })
      return this.refreshList()
    },
    async keyBusca (e) {
      let keyCode = e.event.key
      if (keyCode === 'ArrowUp') {
        await this.selectRowKey('up')
      } else if (keyCode === 'ArrowDown') {
        await this.selectRowKey('down')
      } else if (keyCode === 'Enter') {
        let value = e.element.children[0].children[1].value
        if (value === this.busca) this.setRegistro()
      } else if (keyCode === 'Escape') {
        this.$emit('onCancel')
      }
    },
    limpaBuscaVazia (e) {
      if (e.element.querySelector('input').value === '') return this.executaBusca()
    },
    async validaPermissao (param) {
      try {
        if (this.permissoes[param].pedir_senha) await this.validaSenhaAsync({ funcionalidade: this.acoes[param] })
        if (!this.permissoes[param].pedir_senha && !this.permissoes[param].habilitado) throw new Error('Funcionalidade não habilitada!')
      } catch (e) {
        this.toaster({ message: e.message, color: 'error' })
        throw e
      }
    },
    async validaPermissaoRelatorio (item) {
      try {
        if (item.acesso.pedir_senha) await this.validaSenhaAsync({ funcionalidade: item.funcionalidade_identificacao })
        if (!item.acesso.pedir_senha && !item.acesso.habilitado) throw new Error('Funcionalidade não habilitada!')
      } catch (e) {
        this.toaster({ message: e.message, color: 'error' })
        throw e
      }
    },
    async onAdd () {
      await this.validaPermissao('add')
      this.$emit('onAdd')
    },
    async actOutroBotao (item, data) {
      await this.validaPermissao(item.permissao)
      return item.evento(data)
    },
    async onEdit (data) {
      await this.validaPermissao('edit')
      this.$emit('onEdit', data)
    },
    async onDelete (data) {
      await this.validaPermissao('delete')
      this.$emit('onDelete', data)
    },
    carregaRelatorios () {
      if (this.tela) {
        this.relatorios = this.relatoriosTela(this.tela)
        this.impressao = this.impressaoTela(this.tela)
      }
    },
    async abreRelatorio (item) {
      await this.validaPermissaoRelatorio(item)
      await this.openRelatorio(item.id)
    }
  }
}
</script>

<template>
  <dx-data-grid
    ref="dataGrid"
    :height="300"
    :columns="columns"
    :show-borders="true"
    :data-source="dtSource"
    :remote-operations="remoteOperations"
    :paging="paging"
    :pager="pager"
    :onToolbarPreparing="loadTollbar"
    :selection="{ mode: 'single' }"
    :onRowClick="clickRow"
    :onContentReady="onContentReady"
    :scrolling="scrolling">
    <div slot="pesquisaDiv" slot-scope="data" class="slot-header">
      <div class="indicePesquisa">
        <div class="label">Indices:</div>
        <ui-field-checkbox :value="indicesBusca" @change="v => indicesBusca = v" :items="indices" />
      </div>
      <div class="pesquisar">
        <div class="label">Busca:</div>
        <dx-text-box
          ref="campoBusca"
          mode="search"
          type="search"
          placeholder="Pesquisar..."
          v-model="busca"
          class="busca"
          :onChange="executaBusca"
          :onInput="limpaBuscaVazia"
          :onKeyDown="keyBusca" />
      </div>
      <dx-button @click="executaBusca"> <i class="dx-icon-search" /> </dx-button>
    </div>
    <div slot="selecionarDiv" slot-scope="data" class="slot-header">
      <dx-button @click="setRegistro" v-if="selection"> <i class="dx-icon-check" /> Selecionar </dx-button>
    </div>
    <div slot="printDiv" slot-scope="data" class="slot-header">
      <dx-button @click="print" v-if="impressao"> <i class="dx-icon-print" /> </dx-button>
    </div>
    <div slot="refreshDiv" slot-scope="data" class="slot-header">
      <dx-button @click="refreshList"> <i class="dx-icon-refresh" /> </dx-button>
    </div>
    <div slot="relatorioDiv" slot-scope="data" class="slot-relatorio">
      <dx-button v-if="relatorios.length > 0" @click="$refs.modalRelatorios.open(relatorios)" class="button-relatorio">  <i class="dx-icon-exportselected" /> Relatórios </dx-button>
      <ui-modal-relatorios ref="modalRelatorios" @escolhe="abreRelatorio" />
    </div>
    <div slot="addDiv" slot-scope="data" class="slot-header">
      <dx-button @click="onAdd()" v-if="permissoes.add.visivel"> <i class="dx-icon-plus" /> </dx-button>
    </div>
    <div slot="SouNTemplate" slot-scope="data">
      {{ data.value === 'S' ? 'Sim' : 'Não' }}
    </div>
    <div slot="acaoCell" slot-scope="data">
      <div class="btn-acoes">
        <span v-for="(item, indice) in outrosBotoes" :key="indice">
          <dx-button @click="actOutroBotao(item, data)" v-if="permissoes[item.permissao].visivel">
            <i :class="`dx-icon-${item.class}`" />
          </dx-button>
        </span>
        <span>
          <dx-button @click="onEdit(data)" v-if="permissoes.edit.visivel"> <i class="dx-icon-edit" /> </dx-button>
        </span>
        <span>
          <dx-button @click="onDelete(data)" v-if="permissoes.delete.visivel"> <i class="dx-icon-trash" /> </dx-button>
        </span>
      </div>
    </div>
  </dx-data-grid>
</template>

<style scoped>
  .pesquisar {
    width: 280px;
    font-size: 12px;
    padding-top: 0px;
    margin: 0;
    float: left;
    margin-right: 5px;
  }
  .pesquisar .dx-texteditor, .pesquisar .dx-texteditor-container, .pesquisar input {
    width: 100%;
  }
  .indicePesquisa {
    width: 200px;
    font-size: 12px;
    padding-top: 0px;
    margin: 0;
    float: left;
    margin-right: 5px;
  }
  .indicePesquisa .dx-texteditor, .indicePesquisa .dx-texteditor-container, .indicePesquisa input {
    width: 100%;
  }
  .slot-header .dx-button {
    margin-top: 22px;
  }
  .btn-acoes span .dx-button {
    margin-left: 5px;
  }
  .btn-acoes span:last-child .dx-button {
    margin-right: 5px;
  }
  .slot-relatorio {
    margin-top: 22px;
  }
</style>
